<div class='navigation'>
  <div class='column'>
    <a [class.active]='section === "main"' [routerLink]='"/"'>ראשי</a>
    <a [class.active]='section === "database"' [routerLink]='"/database"'>מאגר המידע</a>
    <a [class.active]='section === "en"' [routerLink]='"/en"'>About WPA-IL</a>
    <a [class.active]='section === "ar"' [routerLink]='"/ar"'>حول</a>
  </div>
</div>